import { axiosApi } from '@/config';
import { AuthResponseDto, LogoutResponseDto, LoginCredentials } from '../interfaces';

// Login: envía credenciales en el body (incluye contexto de portal si aplica)
export const login = async (
	credentials: LoginCredentials,
): Promise<AuthResponseDto> => {
	try {
		const response = await axiosApi.post('/auth/login', credentials);
		return response.data;
	} catch (error) {
		console.error('Error al iniciar sesión:', error);
		throw error;
	}
};

// Logout: solo header Authorization, sin body
export const logout = async (accessToken: string): Promise<LogoutResponseDto> => {
	try {
		const response = await axiosApi.post('/auth/logout', null, {
			headers: { Authorization: `Bearer ${accessToken}` },
		});
		return response.data; // { message: 'Sesión cerrada correctamente' }
	} catch (error) {
		console.error('Error al cerrar sesión:', error);
		throw error;
	}
};
